import * as React from 'react';
import { IEngagementData } from '../../../facets/LoggerFacets';
import { connectToItemCache } from '../../decorators/connectToItemCache';
import { IItemCache } from '../../../models/IItemCacheObserver';
import { IActionProps, Action, IActionBaseProps } from '../../action/Action';
import { withSelectedItems, withExactlyOneItem, ISpecifiedItemsProps } from '../../decorators/selectors';
import { IDispatch } from '../../../store/actions/createActionCreator';
import { IItemCacheState } from '../../../store/reducers/itemCacheReducer';
import { IOnExecuteProps } from '../../commandSet/CommandSet';
import { followItem as followItemDefault } from '../../../operations/followItem';
import { followedItemFacet, isFollowedFacet } from '../../../facets/ItemFacets';
import { enableFollowItemConfigurationFacet, configurationItemKey } from '../../../facets/ConfigurationFacets';

export interface IFollowItemActionProps {
  itemKey: string;
}

export const ItemFollowAction = connectToItemCache((itemCache: IItemCache, props: IFollowItemActionProps):
  Pick<IActionProps, 'isAvailable' | 'isToggled' | 'onExecute' | 'engagement'> => {
  const {
    itemKey
  } = props;

  const { dispatch } = itemCache;
  const isFollowFileEnable = itemCache.demandItemFacet(enableFollowItemConfigurationFacet, configurationItemKey);

  if (!isFollowFileEnable) {
    return {
      isAvailable: false
    };
  }

  const followedItem = itemCache.demandItemFacet(followedItemFacet, itemKey);
  const followedItemKey = followedItem && followedItem.itemKey || '';
  const isFollowed = itemCache.demandItemFacet(isFollowedFacet, followedItemKey);
  const isFollowedResolved = itemCache.isItemFacetResolved(isFollowedFacet, followedItemKey);

  const onFollowItem = async () => {
    await dispatch(followItemDefault({
      items: {
        [followedItemKey]: { isFollowed: !isFollowed }
      }
    }));
  };

  const isAvailable = !!followedItem && isFollowedResolved;

  return {
    isAvailable: isAvailable,
    isToggled: !!isFollowed,
    onExecute: onFollowItem,
    engagement: {
      name: 'Follow',
      isIntentional: true
    }
  };
})(Action);

export const FollowAction = withSelectedItems()(withExactlyOneItem()(ItemFollowAction));

// @ts-ignore
type __unused_declarations = Pick<
  IDispatch<never> |
  React.Component |
  IItemCacheState |
  ISpecifiedItemsProps |
  IOnExecuteProps |
  IActionBaseProps |
  IEngagementData,
  never>;
